var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 18,
    viewBox: "0 0 56 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1845 0C32.24 0 28.7149 2.04454 28.7149 5.822C28.7149 10.154 34.9667 10.4532 34.9667 12.6295C34.9667 13.5459 33.9166 14.3661 32.123 14.3661C29.5776 14.3661 27.6751 13.22 27.6751 13.22L26.8611 17.0318C26.8611 17.0318 29.0527 18 31.9624 18C36.275 18 39.6686 15.8551 39.6686 12.013C39.6686 7.43546 33.3907 7.14514 33.3907 5.12518C33.3907 4.40736 34.2528 3.62084 36.0412 3.62084C38.0592 3.62084 39.7055 4.45441 39.7055 4.45441L40.5022 0.772793C40.5022 0.772793 38.7108 0 36.1845 0ZM0.0955137 0.277859L0 0.833575C0 0.833575 1.65949 1.13729 3.15412 1.74313C5.07859 2.43784 5.21569 2.84227 5.5398 4.09841L9.07163 17.7135H13.8061L21.0999 0.277859H16.3763L11.6896 12.1324L9.77713 2.08394C9.60175 0.933896 8.71335 0.277859 7.6259 0.277859H0.0955137ZM22.9993 0.277859L19.2938 17.7135H23.7981L27.4906 0.277859H22.9993ZM48.1216 0.277859C47.0354 0.277859 46.4599 0.859369 46.0376 1.87554L39.4385 17.7135H44.1621L45.076 15.0738H50.8307L51.3864 17.7135H55.5543L51.9182 0.277859H48.1216ZM48.7359 4.98842L50.136 11.5311H46.3849L48.7359 4.98842Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0e9a0183d12781d8068eea117905c11b.svg";
export { ForwardRef as ReactComponent };